import { useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { GeometrisDeviceCommandInput } from "../../../common/data/service-proxies";
import { HookFormSimpleForm } from "../../common/form/hook-form/HookFormSimpleForm";
import { HookFormTextInput } from "../../common/form/hook-form/inputs/HookFormTextInput";
import { GeometrisDeviceSelectorInput } from "./GeometrisDeviceSelectorInput";

interface Props {}

export const GeometrisCustomCommandForm = (props: Props) => {
  const translate = useTranslate();
  const { control } = useFormContext<GeometrisDeviceCommandInput>();
  return (
    <HookFormSimpleForm {...props}>
      <GeometrisDeviceSelectorInput<GeometrisDeviceCommandInput>
        {...props}
        control={control}
      />
      <HookFormTextInput<GeometrisDeviceCommandInput>
        {...props}
        control={control}
        name="command"
        label="Command"
        rules={{ required: translate("ra.validation.required") }}
        options={{ InputProps: { multiline: true, rows: 4 } }}
      />
    </HookFormSimpleForm>
  );
};
